import { Link } from '@tanstack/react-router';
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { api, ApiError } from '../api/client';
import { Empty, Toast } from '../components/ui';
import { absTime, when } from '../hooks/format';
import { useActivity } from '../hooks/queries';

export function Activity() {
  const q = useActivity();
  const qc = useQueryClient();
  const [toast, setToast] = useState<string | null>(null);
  const act = async (url: string, msg: string) => {
    try {
      await api.post(url);
      await qc.invalidateQueries();
      setToast(msg);
    } catch (e) {
      setToast(e instanceof ApiError ? e.message : 'failed');
    }
  };
  if (q.isLoading) return <div className="empty">…</div>;
  const a = q.data;
  if (!a) return null;
  return (
    <div className="page">
      <h1 className="t-h" style={{ margin: '8px 0 14px' }}>Activity</h1>
      {a.held_intents.length === 0 && a.candidate_assets.length === 0 && <Empty>Nothing needs you right now.</Empty>}
      {a.held_intents.map((i) => (
        <div key={i.id} className="card" style={{ borderColor: 'var(--warn)' }}>
          <div className="t-cap warn">Held for your approval · {i.narrative_title}</div>
          <div className="t-em" style={{ marginTop: 4 }}>{i.type} {i.asset}{i.target.value ? ` → ${(Number(i.target.value) * 100).toFixed(0)}% ${i.target.kind === 'WEIGHT_OF_ALLOCATION' ? 'of allocation' : 'of position'}` : ''}</div>
          <div className="t-sec muted" style={{ marginTop: 4 }}>{i.rationale}</div>
          <div className="t-sec faint" style={{ marginTop: 4 }}>Valid until {absTime(i.valid_until)} ({when(i.valid_until)}). Expiry means no action.</div>
          {i.report_id && <Link to="/n/$slug/report/$id" params={{ slug: i.narrative_slug, id: i.report_id }} className="t-sec">Read the report →</Link>}
          <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
            <button className="btn primary block" onClick={() => void act(`/api/v1/intents/${i.id}/approve`, 'Approved; the order is created at the next execution cycle')}>Approve</button>
            <button className="btn block" onClick={() => void act(`/api/v1/intents/${i.id}/reject`, 'Rejected')}>Reject</button>
          </div>
        </div>
      ))}
      {a.candidate_assets.map((c) => (
        <div key={c.id} className="card">
          <div className="t-cap">Candidate asset</div>
          <div className="t-em" style={{ marginTop: 4 }}>{c.handle} <span className="pill">{c.role}</span></div>
          <div className="t-sec muted" style={{ marginTop: 4 }}>{c.rationale}</div>
          <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
            <button className="btn block" onClick={() => void act(`/api/v1/narratives/${c.narrative_slug}/assets/${c.id}/approval`, 'Approved')}>Approve</button>
            <Link to="/n/$slug" params={{ slug: c.narrative_slug }} search={{ tab: 'assets' }} className="btn block">Review</Link>
          </div>
        </div>
      ))}
      <div className="t-cap" style={{ margin: '18px 0 8px' }}>Recent</div>
      <div className="card">
        {a.recent.length === 0 && <div className="muted t-sec">Quiet.</div>}
        {a.recent.map((e) => <div key={e.seq} className="row list-item"><span className="t-sec">{e.type.replace('.', ' · ').replace(/_/g, ' ')}</span><span className="faint t-sec">{when(e.occurred_at)}</span></div>)}
      </div>
      <Toast message={toast} onDone={() => setToast(null)} />
    </div>
  );
}
